import addFileProviderToUserAccount from './addFileProviderToUserAccount';
import getProviderTypeFromAddProviderRedirectUrl from '../utils/getProviderTypeFromAddProviderRedirectUrl';
import { action } from 'satcheljs/lib/legacy';
import { clearAuthWindowInfo, getAuthWindowInfo } from './helpers/AuthWindowInfo';
import { parse } from 'querystring';
function getProviderTypeFromRedirectUrl(redirectUrl) {
    var queryStringStartIndex = redirectUrl.indexOf('?');
    var queryString = queryStringStartIndex !== -1 ? redirectUrl.slice(queryStringStartIndex + 1) : '';
    var queryStringValues = parse(queryString);
    var providerType = getProviderTypeFromAddProviderRedirectUrl(queryStringValues || {});
    return providerType;
}
export default action('addFileProviderAfterAuthFinished')(function addFileProviderAfterAuthFinished(redirectUrl) {
    var providerType = getProviderTypeFromRedirectUrl(redirectUrl);
    if (!providerType) {
        throw new Error('Could not find the provider type');
    }
    var authWindowInfo = getAuthWindowInfo(providerType);
    return addFileProviderToUserAccount(redirectUrl, providerType, authWindowInfo.getAddableFileProviderInfo)
        .then(function (fileProvider) {
        clearAuthWindowInfo(providerType);
        authWindowInfo.onProviderAdded(fileProvider);
    })
        .catch(function (error) {
        clearAuthWindowInfo(providerType);
        authWindowInfo.onErrorAddingProvider(error);
    });
});
//# sourceMappingURL=addFileProviderAfterAuthFinished.js.map